import { createComponentStore } from '../../utils/createComponentStore';

const initData = () => ({
  tableId: '',
  outputPlaceholder: 'new_row_id',
  columns: [],
});

const onLoadData = (data) => ({
  tableId: data?.tableId || '',
  outputPlaceholder: data?.outputPlaceholder || 'new_row_id',
  columns: data?.columns || [],
});

const { getStore: getCreateRowV2Store, defaultStore } = createComponentStore({
  type: 'create_row_v2',
  endpoint: 'create_row_v2',
  registryKey: 'create_row_v2',
  initData,
  onLoadData,
});

export { getCreateRowV2Store, defaultStore };
export default defaultStore;
